/* eslint-disable no-dupe-keys */
const styleBase = (color) => ({
  container: (provided) => ({ ...provided }),
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: '0px',
    paddingBottom: '0px',
    // overflow: 'hidden',
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: '0 0 0 1px transparent',
    borderColor: color || '#F4F7FE',
    borderWidth: '1px',
    backgroundColor: color || '#F4F7FE',
    minHeight: '45px',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    color: '#636363',
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  singleValue: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    color: color ? '#FFFFFF' : '#1B2559',
  }),
  multiValue: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    backgroundColor: '#fff',
  }),
  multiValueLabel: (provided) => ({ ...provided }),
  multiValueRemove: (provided) => ({
    ...provided,
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: 'rgb(230, 230, 230)',
    },
  }),
  input: (provided) => ({
    ...provided,
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: color ? '#FFFFFF' : '#1B2559',
    padding: '8px 4px',
    visibility: state.isDisabled ? 'hidden' : 'inherit',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    backgroundColor: state.isSelected ? '#717A97' : '',
    color: state.isSelected ? '#FFFFFF' : '#000000',
    cursor: 'pointer',
    fontFamily: 'Manrope-Regular',
    '&:hover': {
      backgroundColor: state.isSelected ? '#717A97' : 'rgba(113,122,151, 0.2)',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '8px 0 ',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '42px',
  }),
});

const styleRequest = (color) => ({
  container: (provided) => ({ ...provided }),
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: '0px',
    paddingBottom: '0px',
    // overflow: 'hidden',
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: '0 0 0 1px transparent',
    borderColor: '#FFFFFF',
    borderWidth: '1px',
    backgroundColor: '#FFFFFF',
    minHeight: '45px',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    color: '#636363',
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  singleValue: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    color: color ? '#FFFFFF' : '#1B2559',
  }),
  multiValue: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    backgroundColor: '#fff',
  }),
  multiValueLabel: (provided) => ({ ...provided }),
  multiValueRemove: (provided) => ({
    ...provided,
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: 'rgb(230, 230, 230)',
    },
  }),
  input: (provided) => ({
    ...provided,
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: color ? '#FFFFFF' : '#1B2559',
    padding: '8px 4px',
    visibility: state.isDisabled ? 'hidden' : 'inherit',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    backgroundColor: state.isSelected ? '#717A97' : '',
    color: state.isSelected ? '#FFFFFF' : '#000000',
    cursor: 'pointer',
    fontFamily: 'Manrope-Regular',
    '&:hover': {
      backgroundColor: state.isSelected ? '#717A97' : 'rgba(113,122,151, 0.2)',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '8px 0 ',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '42px',
  }),
});

const styleBold = () => ({
  container: (provided) => ({ ...provided }),
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: '0px',
    paddingBottom: '0px',
    // overflow: 'hidden',
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: '0 0 0 1px transparent',
    borderColor: '#000000',
    borderWidth: '1px',
    backgroundColor: 'transparent',
    minHeight: '45px',
    borderRadius: '3px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular-Bold',
    textTransform: 'uppercase',
    fontSize: '14px',
    color: '#636363',
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px',
    fontFamily: 'Manrope-Regular-Bold',
    textTransform: 'uppercase',
  }),
  multiValue: (provided) => ({
    ...provided,
    fontSize: '14px',
    fontFamily: 'Manrope-Regular-Bold',
    textTransform: 'uppercase',
  }),
  multiValueLabel: (provided) => ({ ...provided }),
  multiValueRemove: (provided) => ({ ...provided }),
  input: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular-Bold',
    textTransform: 'uppercase',
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#000000',
    padding: '8px 4px',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    backgroundColor: state.isSelected ? '#edebeb' : '',
    color: '#000000',
    cursor: 'pointer',
    fontFamily: 'Manrope-Regular-Bold',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: state.isSelected ? '#edebeb' : '#dbd7d7',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '8px 0 ',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '37px',
  }),
});

const styleDiscount = () => ({
  container: (provided) => ({ ...provided }),
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: '0px',
    paddingBottom: '0px',
    // overflow: 'hidden',
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: '0px 18px 32px 0px rgba(208, 210, 218, 0.15)',
    borderColor: '#6AA187',
    borderWidth: '1px',
    backgroundColor: '#E1FBEF',
    minHeight: '45px',
    borderRadius: '8px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    color: '#636363',
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  singleValue: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    color: '#1B2559',
  }),
  multiValue: (provided) => ({
    ...provided,
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    backgroundColor: '#fff',
  }),
  multiValueLabel: (provided) => ({ ...provided }),
  multiValueRemove: (provided) => ({
    ...provided,
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: 'rgb(230, 230, 230)',
    },
  }),
  input: (provided) => ({
    ...provided,
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#1B2559',
    padding: '8px 4px',
    visibility: state.isDisabled ? 'hidden' : 'inherit',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    backgroundColor: state.isSelected ? '#6AA187' : '',
    color: state.isSelected ? '#FFFFFF' : '#000000',
    cursor: 'pointer',
    fontFamily: 'Manrope-Regular',
    '&:hover': {
      backgroundColor: state.isSelected ? '#6AA187' : 'rgba(113,122,151, 0.2)',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '8px 0 ',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '42px',
  }),
});

export {
  styleBase,
  styleBold,
  styleRequest,
  styleDiscount,
};
